import { InputLabel, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Custom Status Filter Input Component
export const StatusFilter = ({ item, applyValue, status }) => {
  const { t } = useTranslation();
  const [filterValue, setFilterValue] = useState(item.value || '');

  const handleFilterChange = (event) => {
    setFilterValue(event.target.value);
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <>
      <InputLabel shrink htmlFor="status">
        {t('value')}
      </InputLabel>
      <Select
        value={filterValue}
        onChange={handleFilterChange}
        fullWidth
        label="status"
      >
        {Object.keys(status).map((key) => (
          <MenuItem key={key} value={key}>
            {t(status[key].label)}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
